<template>
    <BaseDialog :title="infoDialogConfig.title" :visible="infoDialogVisible" append-to-body width="800px" @close="close">
        <template slot="body">
            <el-form :model="form" :rules="rules" ref="form" label-width="150px" label-position="right">
                <el-row>
<!--                            <el-col :span="24" v-show="getGlobalConfig().isDev">
                                <el-form-item label="企业名称">
                                    <el-input v-model="form.compMc" placeholder="请输入企业名称" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>-->
                            <el-col :span="12">
                                <el-form-item label="疫苗名称" prop="vaccYmmc">
                                    <el-select v-model="form.vaccYmmc" :disabled="disabled" placeholder="请选择疫苗名称" class="pctw100">
                                        <el-option v-for=" item in vaccYmList" :key="item.trpId" :label="item.trpMc" :value="item.trpMc">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="接种时间" prop="vaccJzsj">
                                    <el-date-picker v-model="form.vaccJzsj" :disabled="disabled" type="date" editable placeholder="请输入接种时间" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="接种人" prop="vaccJzr">
                                    <el-input v-model="form.vaccJzr" :disabled="disabled" placeholder="请输入接种人"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="疫苗图片" prop="vaccYmtp">
                                  <card-upload v-model="fileList1" :limit="num" :disabled="disabled" accept=".png,.jpg" ref="uploadFile1"></card-upload>
                                </el-form-item>
                            </el-col>
                </el-row>

            </el-form>
        </template>

        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="confirm" v-show="!disabled">确 定</el-button>
        </span>
    </BaseDialog>
</template>

<script>
    export default {
        name: "infoDialog",
        props: {
            infoDialogConfig: {
                type: Object,
                default: () => {
                },
            },
            infoDialogVisible: {
                type: Boolean,
                default: () => false,
            },
        },
        data() {
            return {
                form: {
                    vaccId: '',
                    batchNum: '',
                    compId: JSON.parse(sessionStorage.getItem('user')).organId,
                    compBh: '',
                    compMc: '',
                    vaccYmmc: '',
                    vaccJzsj: '',
                    vaccJzr: '',
                    vaccYmtp: '',
                    createTime: '',
                    createUserId: '',
                    createUserName: '',
                },
                rules: {
                    vaccYmmc: [{
                        required: true,
                        message: "请选择疫苗",
                        trigger: "submit",
                    },],
                    vaccJzsj: [{
                        required: true,
                        message: "请输入接种时间",
                        trigger: "submit",
                    },],
                    vaccJzr: [{
                        required: true,
                        message: "请输入接种人",
                        trigger: "submit",
                    },],
                },
                options: [],
                dialogVisible: false,
                //企业名称
                compList: [],
                //疫苗名称
                vaccYmList: [],
                // 上传文件
                fileList1: [],
                num: 1,
                disabled:false,
            };
        },
        computed: {},
        mounted() {
            this.vaccYmList = this.infoDialogConfig.vaccYmList;
            this.compList = this.infoDialogConfig.compList;
            this.form.compId = this.compList[0].compId;
            this.form.compBh = this.compList[0].compBh;
            this.form.compMc = this.compList[0].compMc;
            this.form.batchNum = this.infoDialogConfig.batchNum;
            if (this.infoDialogConfig.data) {
                for (const key in this.infoDialogConfig.data) {
                    for (const k in this.form) {
                        if (key === k) {
                            this.form[k] = this.infoDialogConfig.data[key];
                        }
                    }
                }
                if (this.form.vaccYmtp) {
                  this.fileList1.push({
                    fileId: this.form.vaccYmtp
                  });
                }
            }
          this.disabled = this.infoDialogConfig.disabled;
        },

        methods: {
            close() {
                this.$emit("update:infoDialogVisible", false);
            },
            confirm() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let params = JSON.parse(JSON.stringify(this.form));
                        if (this.fileList1.length > 0) {
                          params.vaccYmtp = this.fileList1[0].fileId;
                        }else {
                          params.vaccYmtp = '';
                        }
                        if (params.vaccId) {
                            this.$api
                                .formPost("/api/major/breed/vaccine/doModById", params)
                                .then((res) => {
                                    this.$message.success("操作成功");
                                    this.close();
                                    this.$emit("onSuccess");
                                });
                        } else {
                            delete params.vaccId;
                            this.$api
                                .formPost("/api/major/breed/vaccine/doSave", params)
                                .then((res) => {
                                    this.$message.success("操作成功");
                                    this.close();
                                    this.$emit("onSuccess");
                                });
                        }
                    }
                });
            },

        },
    };
</script>

<style lang="scss" scoped>
    .userInfo {
        width: 240px;
        display: flex;
        flex-direction: column;
        height: 100%;

    .info {
        font-size: var(--text-size);
        display: flex;
        justify-content: space-between;
        padding: 13px 0px;
        border-bottom: 1px solid #ccc;

    .title {
        min-width: 70px;
    }
    }
    }

    .avatar-uploader {
        width: 100%;
        border: 1px dotted #ccc;
        text-align: center;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 240px;
        height: 240px;
        line-height: 240px;
        text-align: center;
    }

    .avatar {
        width: 240px;
        height: 240px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/breedVaccine/components/infoDialog.vue